'use client';

import { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { AdminLayoutClient } from '@/pages/admin/AdminLayoutClient';
import { useSession } from '@/lib/auth-client';

export function AdminLayout() {
  const { data: session, status } = useSession();
  const location = useLocation();
  const navigate = useNavigate();
  const isLogin = location.pathname === '/admin/login';

  useEffect(() => {
    if (status === 'loading') return;
    if (!session && !isLogin && location.pathname !== '/admin/guide') {
      if (location.pathname === '/admin') {
        navigate('/admin/login', { replace: true });
      }
    }
  }, [session, status, isLogin, location.pathname, navigate]);

  return (
    <AdminLayoutClient session={session}>
      <Outlet />
    </AdminLayoutClient>
  );
}
